export const getMimeType = (fileExtension: string) => {
  switch (fileExtension) {
    case '.jpg':
    case '.jpeg':
      return 'image/jpeg'
    case '.png':
      return 'image/png'
    case '.gif':
      return 'image/gif'
    case '.mov':
      return 'video/quicktime'
    case '.mp4':
      return 'video/mp4'
    case '.mp3':
      return 'audio/mpeg'
    case '.wav':
      return 'audio/wav'
    case '.ogg':
      return 'audio/ogg'
    case '.mpeg':
      return 'video/mpeg'
    default:
      return 'application/octet-stream'
  }
}

export const getFileExtension = (url: string) => {
  const reWithSpecial = /\.{1}([\w]{1,4})(?=[#?$])/g
  const reSimple = /\.{1}([\w]{1,4})/g
  const matchWithSpecial = url.match(reWithSpecial)
  const matchSimple = url.match(reSimple)
  if (matchWithSpecial) {
    return matchWithSpecial[0]
  }
  if (matchSimple) {
    return matchSimple[matchSimple.length - 1]
  }
  return null
}
